import React, { useEffect } from 'react';
import { useStores } from 'src/hooks/use-stores';
import { FullPageLoader } from 'shared/components';
import PublicEnv from 'shared/utils/public-env';

export const getZendeskLoginUrl = (appEnv: string | undefined, token: string | null | undefined): string => {
  const subdomain = appEnv === 'production' ? 'dutchie' : 'dutchie1601064859';
  return `https://${subdomain}.zendesk.com/access/jwt?jwt=${token}`;
};

export default function ZendeskLogin(): JSX.Element {
  const { User } = useStores();
  const subdomain = PublicEnv.appEnv === 'production' ? 'dutchie' : 'dutchie1601064859';

  useEffect(() => {
    const { zendeskSingleSignOnToken } = User._user;
    // Assigning Location.href invokes the same Location stringifier/navigation algorithm as
    // assigning a string to window.location, while satisfying the DOM TypeScript contract.
    window.location.href = getZendeskLoginUrl(PublicEnv.appEnv, zendeskSingleSignOnToken);
  }, [User._user, subdomain]);

  return <FullPageLoader />;
}
